export const BOTSPEC_ID = 'botspec';
export const GLOBAL_ID = 'global';

export const BOTSPEC_LABEL = 'Botspec Functions';
export const GLOBAL_LABEL = 'Global Functions';

const functionsDescription = {
  botspec: {
    id: BOTSPEC_ID,
    label: BOTSPEC_LABEL,
    editable: true,
  },
  global: {
    id: GLOBAL_ID,
    label: GLOBAL_LABEL,
    editable: false,
  },
};

export default functionsDescription;
